var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',

    props: {
        target: String,
    },

    data: {},

    connect() {
        this.items = $(this.target).find('[data-search]');
    },

    events: [{
        name: 'keyup',
        handler(ev) {
            var query = $(this.el).val().toLowerCase();
            $.each(this.items, function () {
                var item = $(this);
                if (item.attr('data-search').indexOf(query) === -1) {
                    item.addClass('d-none');
                } else {
                    item.removeClass('d-none');
                }
            });
        }
    }],

    methods: {
    },

}
